// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu2 = () => {
    const { menuDashboard2 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard2?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard2.id,
        title: <FormattedMessage id={`${menuDashboard2.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard2.icon],
        type: menuDashboard2.type,
        children: ChildrenList
    };

    return dashboardList;
};
